import React from "react";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import IfLoggedIn from "../components/ifLoggedIn/IfLoggedIn";
import Login from "../pages/login/Login";
import BootstrapPage from "../pages/BootstrapPage";
import { connect } from "react-redux";
import EngineeringPage from "../pages/EngineeringPages/EngineeringPage";
import PIDdragandDrop from "../components/pidLegend/PIDdragandDrop";
import SupplierZone from "../pages/SupplierPages/SupplierZone";
import FeedBack from "../pages/feedBack/FeedBack";
import Training from "../pages/training/Training";
import TrainingPages from "../pages/training/TrainingPages";

class Router extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <BrowserRouter>
        <Switch>
          <Route exact path="/">
            <Login />
          </Route>
          <Route
            exact
            path="/main"
            render={(props) => <IfLoggedIn {...props} />}
          />
          <Route
            exact
            path="/engineering"
            render={(props) => <IfLoggedIn {...props} />}
          />
          <Route
            exact
            path="/SketchUp"
            render={(props) => <IfLoggedIn {...props} />}
          />
          <Route
            exact
            path="/dsear"
            render={(props) => <IfLoggedIn {...props} />}
          />
          <Route
            exact
            path="/dsearNew"
            render={(props) => <IfLoggedIn {...props} />}
          />
          <Route
            exact
            path="/supplier"
            render={(props) => <IfLoggedIn {...props} />}
          />
          <Route
            exact
            path="/feedback"
            render={(props) => <IfLoggedIn {...props} />}
          />
          <Route
            exact
            path="/training"
            render={(props) => <IfLoggedIn {...props} />}
          />
          <Route
            exact
            path="/personalHub"
            render={(props) => <IfLoggedIn {...props} />}
          />
          <Route exact path="/bootstrap">
            <BootstrapPage />
          </Route>
          <TrainingPages />
          <Route render={() => <Redirect to="/" />} />
        </Switch>
      </BrowserRouter>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.requestUserDataReducer.data,
});

export default connect(mapStateToProps)(Router);
